import BundleProductSpecificationsIdentifier from "../constants/BundleProductSpecificationsIdentifier";
import { IBundleProductCharacteristic, IDisplaySpecification } from "../entities/manhattan/bundle/types";

export default class BundleProductCharacteristicService {

  private static instance: BundleProductCharacteristicService;
  private bundleProductCharacteristics: IBundleProductCharacteristic[];

  public static getInstance(): BundleProductCharacteristicService {
    if (!this.instance) {
      this.instance = new BundleProductCharacteristicService();
    }

    return this.instance;
  }

  public setBundleProductCharacteristics(bundleProductCharacteristics: IBundleProductCharacteristic[]) {
    this.bundleProductCharacteristics = bundleProductCharacteristics;
  }

  private createSpecificationByIdentifier(char: string) {
    const specifications: IDisplaySpecification[] = [];
    this.bundleProductCharacteristics.forEach((bundleProductCharacteristic: IBundleProductCharacteristic) => {
      if (bundleProductCharacteristic.specificationIdentifier === char) {
        specifications.push({
          id: bundleProductCharacteristic.id,
          value: bundleProductCharacteristic.value,
          valueEn: bundleProductCharacteristic.valueEn,
          characteristicIdentifier: bundleProductCharacteristic.characteristicIdentifier,
          specificationIdentifier: bundleProductCharacteristic.specificationIdentifier,
          specificationItemCharacteristicId: bundleProductCharacteristic.specificationItemCharacteristicId,
          specificationItemCharacteristic: bundleProductCharacteristic.specificationItemCharacteristic,
        });
      }
    });

    if (specifications.length) {
      specifications.sort((a: any, b: any) => {
        return a.specificationItemCharacteristic.order - b.specificationItemCharacteristic.order;
      });
    }

    return specifications;
  }


  public createSpecification() {
    const SI_INTERNET = BundleProductSpecificationsIdentifier.SI_INTERNET;
    const SI_TV = BundleProductSpecificationsIdentifier.SI_TV;
    const SI_LANDLINE = BundleProductSpecificationsIdentifier.SI_LANDLINE;
    const specifications: any = {};
    specifications[SI_INTERNET] = this.createSpecificationByIdentifier(BundleProductSpecificationsIdentifier.SI_INTERNET);
    specifications[SI_TV] = this.createSpecificationByIdentifier(BundleProductSpecificationsIdentifier.SI_TV);
    specifications[SI_LANDLINE] = this.createSpecificationByIdentifier(BundleProductSpecificationsIdentifier.SI_LANDLINE);

    return specifications;
  }

}
